import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import * as React from 'react';

import { EntityType } from '../../../../Common/DataOwnerModels/CDMRecord';
import * as FormStyle from '../../../../Common/Styles/form.styled';
import { MachineLearningEntityTypeSelector } from '../MachineLearningEntityTypeSelector';
import { MachineLearningExperimentWizardStep } from './MachineLearningExperimentWizard';
import {
  MachineLearningExperimentWizardContext,
  MachineLearningExperimentWizardContextProps,
} from './MachineLearningExperimentWizardContext';

export function MachineLearningExperimentDataWizardStep(): React.ReactElement {
  const { experiment, setExperiment, setCompletedSteps, completedSteps } =
    React.useContext<MachineLearningExperimentWizardContextProps>(MachineLearningExperimentWizardContext);
  const { httpClient } = React.useContext(Context as React.Context<IEmployeeExperienceContext>);
  const [entityTypes, setEntityTypes] = React.useState<EntityType[]>([]);

  React.useEffect(() => {
    if (experiment.dataOwnerId == null) return;
    httpClient
      .get<EntityType[]>(
        `${__API_BASE_URL__}/tenant/getApprovedCDMsByTenant?tenantId=${experiment.dataOwnerId}&environment=1`,
        {
          resource: __CLIENT_ID__,
        }
      )
      .then(({ data }) => {
        const sortedCdmList = (data as EntityType[]).sort((a: EntityType, b: EntityType) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        });

        for (const entityType of sortedCdmList) {
          const schema = JSON.parse(entityType.schema);

          let firstLevelProps = {};
          if (schema['type'] == 'array') firstLevelProps = schema['items']['properties'];
          else if (schema['type'] == 'object') firstLevelProps = schema['properties'];
          else firstLevelProps = {};
          const firstLevelPropsArray = Object.keys(firstLevelProps);
          entityType.properties = firstLevelPropsArray.sort((a, b) => a.localeCompare(b));
        }

        setEntityTypes(sortedCdmList);
      });
  }, [experiment.dataOwnerId, httpClient]);

  React.useEffect(() => {
    if (
      !!experiment.baseEntity &&
      !!experiment.baseEntityColumns &&
      completedSteps.indexOf(MachineLearningExperimentWizardStep.DATA) === -1
    )
      setCompletedSteps([...completedSteps, MachineLearningExperimentWizardStep.DATA]);
  }, [completedSteps, experiment, setCompletedSteps]);

  return (
    <FormStyle.MinimumForm>
      <FormStyle.InputGroup>
        <h2>Data configuration</h2>
      </FormStyle.InputGroup>

      <MachineLearningEntityTypeSelector
        disabled={experiment.dataOwnerId == null}
        entityTypes={entityTypes}
        value={experiment}
        onChange={(val) => setExperiment(val)}
      />
    </FormStyle.MinimumForm>
  );
}
